export function getHostname(host = '') {
  return host.replace(/:[0-9]+/, '');
}

export function getCleanStageHostname(hostname: string) {
  const parts = hostname.split('.');

  return parts.length > 4 ? parts.slice(parts.length - 4).join('.') : parts.join('.');
}
